// extracted by mini-css-extract-plugin
module.exports = {"createProjectDialog":"createProjectDialog--Wzb2V","more":"more--1d12J"};